import { create } from 'zustand';
import type { Book } from '../types/index.js';

interface ModalState {
  viewingBook: Book | null;
  certBook: Book | null;
  treeBook: Book | null;
  editingBook: Book | null;
  isFormOpen: boolean;
  createEditionParent: Book | null;
  isScannerOpen: boolean;
  deletingBook: { id: string; title: string } | null;

  setViewingBook: (book: Book | null) => void;
  setCertBook: (book: Book | null) => void;
  setTreeBook: (book: Book | null) => void;
  setEditingBook: (book: Book | null) => void;
  setIsFormOpen: (isOpen: boolean) => void;
  setCreateEditionParent: (book: Book | null) => void;
  setIsScannerOpen: (isOpen: boolean) => void;
  setDeletingBook: (book: { id: string; title: string } | null) => void;
}

export const useModalStore = create<ModalState>((set) => ({
  viewingBook: null,
  certBook: null,
  treeBook: null,
  editingBook: null,
  isFormOpen: false,
  createEditionParent: null,
  isScannerOpen: false,
  deletingBook: null,

  setViewingBook: (book) => set({ viewingBook: book }),
  setCertBook: (book) => set({ certBook: book }),
  setTreeBook: (book) => set({ treeBook: book }),
  setEditingBook: (book) => set({ editingBook: book }),
  setIsFormOpen: (isOpen) => set({ isFormOpen: isOpen }),
  setCreateEditionParent: (book) => set({ createEditionParent: book }),
  setIsScannerOpen: (isOpen) => set({ isScannerOpen: isOpen }),
  setDeletingBook: (deletingBook) => set({ deletingBook }),
}));
